var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/app/module/snap/tpl.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"m-chatpanel-firstmessage T_firstmessage\">\n    <ul class=\"list\" role=\"tree\">\n      ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "suggestions");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("item", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index") < 4) {
output += "\n          <li class=\"li\" role=\"treeitem\">\n            <a href=\"javascript:;\" class=\"J_Category\" data-cid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"categoryId"), env.opts.autoescape);
output += "\">\n              <span>";
output += runtime.suppressValue(runtime.memberLookup((t_4),"category"), env.opts.autoescape);
output += "</span>\n              <svg class=\"icon icon-down\" aria-hidden=\"true\">\n                <use xlink:href=\"#icon-arrow\"></use>\n              </svg>\n            </a>\n            <ul role=\"group\">\n              ";
frame = frame.push();
var t_7 = runtime.memberLookup((t_4),"questions");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("q", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n              <li class=\"sub-list-item\" role=\"treeitem\">\n                <a href=\"javascript:;\" class=\"J_SendText\" data-kid=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"id"), env.opts.autoescape);
output += "\">\n                  <span>";
output += runtime.suppressValue(runtime.memberLookup((t_8),"title"), env.opts.autoescape);
output += "</span>\n                  <svg class=\"icon\" aria-hidden=\"true\">\n                    <use xlink:href=\"#icon-ssend\"></use>\n                  </svg>\n                </a>\n              </li>\n              ";
;
}
}
frame = frame.pop();
output += "\n            </ul>\n          </li>\n        ";
;
}
output += "\n      ";
;
}
}
frame = frame.pop();
output += "\n    </ul>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/app/module/snap/tpl.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/app/module/snap/tpl.html
// module id = 214
// module chunks = 0 1